import { BehaviorSubject, PartialObserver, Subscription } from 'rxjs';
import { GridApi, IServerSideDatasource,	IServerSideGetRowsParams } from '@ag-grid-community/core';

import { DplScope } from '../models/need4steel';

import { Need4SteelService } from './need4steel.api.service';

export class Need4SteelOrderHistoryDataSource implements IServerSideDatasource {
	private sub?: Subscription;
	private readonly showNoRowsOverlaySubject = new BehaviorSubject(<boolean | undefined>undefined);
	constructor(
		readonly need4SteelService: Need4SteelService,
		readonly gridApi: GridApi<Map<string, object>[]>,
		readonly orderHistoryData: DplScope
	) {}

	subscribeToRowsCount(observer: PartialObserver<boolean | undefined>) {
		return this.showNoRowsOverlaySubject.subscribe(observer);
	}

	getRows(params: IServerSideGetRowsParams): void {
		this.showNoRowsOverlaySubject.next(false);
		if (this.sub) {
			this.sub.unsubscribe();
		}
		this.sub = this.need4SteelService.fetchOrdersHistory(this.orderHistoryData).subscribe({
			next: (result: Map<string, object>[]) => {
				params.success({ rowData: result, rowCount: result.length });
				this.showNoRowsOverlaySubject.next(result.length === 0);
			},
			error: (error: unknown) => {
				params.fail();
				console.error(error);
				this.showNoRowsOverlaySubject.next(true);
			}
		});
	}
}
